define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/heading/Enum"
], function(declare,_,Enum) {
	
	return declare(Enum, {
		toHtmlStatic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*ActionData*/actionData) {
			// summary: render value for attribute in HTML and attach action to just widget; output nothing if there is no value
			var value = this._getValue(ctx, h);
			if (value == null)	 {
				refNode.innerHTML = ctx.getNodeAttributeValue("NumResponded", true) + " / " + ctx.getNodeAttributeValue("NumQuestions", true);
				return true;
			}
			
			return this.inherited(arguments);
		}
	});
});
